
import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";
import DoctorsMenu from './includes/DoctorsMenu';
import DoctorsHeader from './includes/DoctorsHeader';
import { _getLoginStatus, _showOverlay, _hideOverlay, _clearAllInterval, _clearInterval, refresh_time, _getUserDoctor } from './includes/Constants';
import { _getAllBooking } from './api/Doctor';
import Toast from './includes/Toast';
import withNavigateHook from './includes/withNavigateHook';
import Loader from './includes/Loader';
const startDate = new Date();
let $ = window.$;
class DoctorsHistory extends Component {

    /**
     * 
     * @param {*} props 
     */
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            list: [],
            message: '',
            type: '',
            visibility: 'hide',
            loader: "hide",
            user_doctor: {}
        }

    }
    /**
      * 
      * @returns 
      */
    componentDidMount = async () => {
        let app = this;

        //alert(  $("#datepicker").datepicker("getDate"));
        let res = await _getLoginStatus();
        //console.log(res);
        if (res['status']) {
            await this.setState({
                user: res.data
            });
            await $("#datepicker").datepicker({
                format: 'yyyy-mm-dd',
                onSelect: function (e) {
                    app._handleChange(e);
                },
                autoClose: true
            }).datepicker("setDate", startDate);
            $('#datepicker').val(startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate());
            //alert(startDate);
            if (res['data']['user_type'] == 'Doctor') {
                let res1 = await _getUserDoctor();
                //console.log(res1);
                if (res1['status']) {
                    await this.setState({
                        user_doctor: res1.data
                    });
                }

                await this._getUpdatedBooking(res1);
                setTimeout(async () => {
                    await this._getAutoRefresh();
                }, 20000);
            } else {
                this.props.navigation('/home');
            }

        } else {
            this.props.navigation('/home');
        }

    }



    /**
    * 
    */
    _getUpdatedBooking = async (res) => {

        if (typeof res.data.id != "undefined" && res.data.id != null) {
            //_showOverlay();
            await this.setState({
                loader: "show",
                message: '',
                type: 'success',
                visibility: 'hide',
            })
            let date = $("#datepicker").val();

            if (typeof date != "undefined" && date != "") {
                let res1 = await _getAllBooking(res.data.id, date, 'Doctor');
                if (res1.data.response == "success") {
                    //alert(date);
                    this.setState({
                        list: res1.data.result,
                        message: res1.data.message,
                        type: 'success',
                        visibility: 'hide',
                        loader: "hide"
                    });
                    //_hideOverlay();
                } else {
                    //alert(2)
                    this.setState({
                        list: [],
                        message: res1.data.error,
                        type: 'error',
                        visibility: 'show',
                        loader: "hide"
                    });
                    //_hideOverlay();
                }
            } else {
                await this.setState({
                    loader: "hide"
                })
            }


        }
        return;
    }

    /**
   * 
   * @returns 
   */
    _getAutoRefresh = async () => {

        this.set_interval = setInterval(async () => {
            //console.log(this.set_interval);
            await _clearInterval(this.set_interval);
            let date = $("#datepicker").val();

            let res1 = await _getAllBooking(this.state.user_doctor.id, date, 'Doctor');
            if (res1.data.response == "success") {

                this.setState({
                    list: res1.data.result,
                    message: '',
                    type: 'success',
                    visibility: 'hide'
                });

            } else {
                this.setState({
                    list: [],
                    message: res1.data.error,
                    type: 'error',
                    visibility: 'show'
                });

            }
        }, refresh_time);

        return;
    }

    /**
     * 
     */
    _getBookingList = () => {
        let total_counter = 0;
        if (Object.keys(this.state.list).length > 0) {
            return (
                Object.values(this.state.list).map((value, index) => {

                    return (
                        Object.values(value).map((value1, index1) => {
                            total_counter = total_counter + 1;
                            return (
                                <div key={"div-" + index1} className="card-panel grey lighten-5 z-depth-1">
                                    <div className="row valign-wrapper">

                                        <div className="col s3">
                                            {
                                                value1.parchee_type == 'New' ?
                                                    <div className="ribbonTxt">New</div>
                                                    :
                                                    ''

                                            }
                                            <img src="images/img3.png" alt="" className="circle responsive-img img-50" />

                                        </div>

                                        <div className="col s6">

                                            <span className="black-text">
                                                <p><b>S.no:</b>&nbsp;{total_counter}</p>
                                                <p><b>Slot:</b>&nbsp;{value1.slot}</p>
                                                <p><b>Patient Visit:</b>&nbsp;{value1.parchee_type == 'New'?'New':'Follow Up'}</p>
                                                <p><b>Name:</b>&nbsp;{value1.patient_history.patient_details.name}</p>
                                                <p><b>Age:</b>&nbsp;{value1.patient_history.patient_details.age}&nbsp;years</p>
                                                <p><b>Problem:</b>&nbsp;{value1.patient_history.patient_details.problem}</p>
                                                <p><b>Address:</b>&nbsp;{value1.patient_history.patient_details.address}&nbsp;</p>
                                            </span>

                                        </div>
                                        <div className="col s3">
                                            <p className="detailBtn">

                                                <Link to="/show-patient-details" state={{ data: value1 }}> Details </Link>
                                            </p>

                                        </div>

                                    </div>

                                </div>
                            )
                        })
                    )

                })
            )
        } else {
            return (

                <div className="col s12 center-align mt-20">
                    <img src="images/not-found.gif" alt="" className="circle responsive-img" />

                </div>



            )
        }

    }

    /**
     * 
     */
    _handleIconClick = () => {
        //alert('ggggg')
        $("#datepicker").datepicker("open");
    }

    /**
     * 
     */
    _handleDateAdd = async () => {
        var date = new Date($("#datepicker").val());
        var newdate = new Date(date);
        newdate.setDate(newdate.getDate() + 1); // minus the date
        var nd = new Date(newdate);
        $("#datepicker").datepicker("setDate", nd);
        let res = [];
        res.data = this.state.user_doctor;
        //await this._getUpdatedBooking(res);
    }

    /**
     * 
     */
    _handleDateSubtract = async () => {
        //alert($("#datepicker").val());
        var date = new Date($("#datepicker").val());
        var newdate = new Date(date);
        newdate.setDate(newdate.getDate() - 1); // minus the date
        var nd = new Date(newdate);
        $("#datepicker").datepicker("setDate", nd);
        let res = [];
        res.data = this.state.user_doctor;
        //await this._getUpdatedBooking(res);
    }

    /**
     * 
     */
    _handleChange = async (date) => {
        //console.log(date)
        $('#datepicker').val(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        await _clearAllInterval();
        let res = [];
        res.data = this.state.user_doctor;
        await this._getUpdatedBooking(res);
    }

    /**
     * 
     * @returns 
     */
    _showDate = () => {
        let get_date = new Date($('#datepicker').val());
        let show_date = get_date.getDate() + '-' + (get_date.getMonth() + 1) + '-' + get_date.getFullYear();

        return (
            <h6 id="show_date" className="center-align">Date: {show_date}</h6>
        )
    }


    render() {

        return (
            <React.Fragment>
                <Loader visibility={this.state.loader} />
                <DoctorsHeader />

                <main role="main">

                    <section id="dashboard-page" className="oparcheecommonCode">

                        <div className="dashboardContent">

                            <div className="container">

                                <div className="row">

                                    <div className="col s12">

                                        <div className="strip">

                                            <div className="row pt-20">

                                                <div className="col s3 left-align">

                                                    <i className="material-icons pointer-p" onClick={() => this._handleDateSubtract()}>chevron_left</i>

                                                </div>

                                                <div className="col s6 center-align">

                                                    <div className="bookingTxt"><h3>
                                                        <i className="material-icons pointer-p" onClick={() => { this._handleIconClick() }}> calendar_today</i>
                                                        <span>Booking History</span></h3>
                                                    </div>
                                                    <input onChange={() => { this._handleChange() }} id="datepicker" style={{ "visibility": "hidden", "height": "0px" }} />
                                                </div>

                                                <div className="col s3 right-align">

                                                    <i className="material-icons pointer-p" onClick={() => this._handleDateAdd()}>chevron_right</i>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col s12">
                                        {this._showDate()}

                                        {this._getBookingList()}
                                    </div>
                                </div>


                                {/* <div className="col s12">

                                        <img className="responsive-img" src="images/banner2.jpg" alt="" />

                                        <a href="" className="upgradebtn"><span>Upgrade to Oparchee Plus</span> <i className="material-icons">arrow_forward</i></a>

                                        <div className="locationName center-align">

                                            <img className="responsive-img" src="images/stethoscope.png" alt="" /> <strong>Doctors in Mumbai</strong>

                                        </div>

                                    </div> */}





                            </div>

                        </div>

                    </section>

                </main>
                <DoctorsMenu />
                {/* {
                    this.state.visibility == 'show'
                        ?
                        <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} />
                        :
                        ''
                } */}
                <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} />
            </React.Fragment>
        );
    }
}

export default withNavigateHook(DoctorsHistory);
